import { useState, useEffect } from 'react'
import IdleTimer from 'react-idle-timer'
import { withRouter } from 'react-router-dom'
import ErrorBoundary from '../Components/ErrorBoundary'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleDown, faPencilAlt, faTrashAlt, faCheck, faTimes, faLock } from '@fortawesome/free-solid-svg-icons'
import { odinUserRepository } from '../../refactory/modules/access-control/infrastructure/odin-user.repository'
import { updateUserV3UseCase } from '../../refactory/modules/access-control/application/update-user-v3.use-case'
import { AccessControl } from '../../refactory/modules/access-control/infrastructure/roles-permissions/access-control'
import { getI18n } from 'react-i18next'
import moment from 'moment-timezone'
import 'moment/min/locales'
import Moment from 'react-moment'
import Routes from '../Components/Routes/Scenes'
import LoadingContainer from '../Components/Loading/Scenes'
import { Notifications } from '../../refactory/kernel/infrastructure/notifications/Notifications.component'
import { getParams } from '../Services/Params/api'
import ModalInactive from './ModalInactive'
import { useAuth } from '../../auth/Auth.hook'

library.add(faAngleDown, faPencilAlt, faTrashAlt, faCheck, faTimes, faLock)

let idleTimer = null
const INACTIVITY_TIMEOUT = 'inactivityTimeout'
const ENTERPRISE = 'enterprise'
const HAS_ECOMMERCE = 'hasEcommerce'
Moment.globalMoment = moment

setTimeout(function () {
  window.local = getI18n().language
  Moment.globalLocale = window.local
  Moment.globalLocal = true
}, 3000)

const toObject = (values) => {
  let obj = {}
  values.forEach(({ key, value }) => {
    obj[key] = value
  })
  return obj
}

const IS_DEVELOPMENT = process.env.REACT_APP_ENV === 'development'

export default withRouter((props) => {
  const { userInfo, getUserProfile, isAuthenticated, loading, loginError, logout } = useAuth()

  const [showModal, setShowModal] = useState(false)
  const [firstLoad, setFirstLoad] = useState(false)
  const [timeout, setLocalTimeout] = useState(0)
  const [isEnterprise, setIsEnterprise] = useState(false)
  const [hasECommerce, setHasEcommerce] = useState(false)
  const [featureFlags, setFeatureFlags] = useState({})

  const getClientParams = async () => {
    try {
      const params = await getParams()
      setFirstLoad(true)
      if (params && params.length) {
        const paramsObject = toObject(params)
        setFeatureFlags(paramsObject)
        setIsEnterprise(paramsObject[ENTERPRISE] === 'true')
        setHasEcommerce(paramsObject[HAS_ECOMMERCE] === 'true')
        if (timeout === 0) {
          setLocalTimeout(Number(paramsObject[INACTIVITY_TIMEOUT] || 1800000))
          idleTimer && idleTimer.reset()
        }
      }
    } catch (error) {
      console.error('something went wrong getting the client params')
    }
  }

  useEffect(() => {
    const getDefaultView = (_) => {
      const currentLocation = `${props.location.pathname}${props.location.search}`
      if (currentLocation) {
        return currentLocation
      }
      return ''
    }

    if (!loading && isAuthenticated && !loginError && AccessControl.abilityInstance && !firstLoad && userInfo) {
      props.history.push(getDefaultView(userInfo))
      getClientParams()
    }
    if (loginError) {
      console.log('Show error window')
    }
  }, [isAuthenticated, loading, loginError, props.history, props.location.pathname, timeout, userInfo])

  const onIdle = async () => {
    const { user } = userInfo
    if (timeout !== 0) {
      if (user && user.isLive) {
        await updateUserV3UseCase(odinUserRepository)(user.id, { isLive: false })
        getUserProfile()
        setShowModal(true)
      }
    }
  }

  const getView = (_) => {
    if (loading || !AccessControl.abilityInstance) {
      return (
        <div className='pre-loading'>
          <img src='./Instaleap-logo.png' alt='Instaleap' />
        </div>
      )
    } else if (!loginError) {
      return (
        <Routes
          currentUser={userInfo}
          isEnterprise={isEnterprise}
          hasECommerce={hasECommerce}
          featureFlags={featureFlags}
        />
      )
    } else {
      if (!IS_DEVELOPMENT) {
        logout({ federated: isEnterprise })
      } else {
        logout()
      }
      return null
    }
  }

  const client = userInfo?.client
  return !isAuthenticated || !userInfo?.user?.email ? null : (
    <ErrorBoundary>
      <IdleTimer
        ref={(ref) => {
          idleTimer = ref
        }}
        onIdle={onIdle}
        timeout={timeout}
        startOnLoad
      >
        {getView()}
        <LoadingContainer color={client?.styles['@primary-color']} />
        <Notifications user={userInfo.user} />
      </IdleTimer>
      <ModalInactive showModal={showModal} setShowModal={setShowModal} timeout={timeout > 0 ? timeout / 60000 : 0} />
    </ErrorBoundary>
  )
})
